export default __webpack_public_path__ + "static/students-walking-homebanner-0df49a475483767743d616e76d91e079.jpg";